import type { ReactNode } from 'react'
import { AuthLayout } from './AuthLayout'

interface OnboardingShellProps {
  title: string
  /**
   * The public join-the-network page: the picture beside the form.
   *
   * <p>Right for someone signing up. Wrong for someone already signed in adding a second profile:
   * for them the picture is a sales pitch for a product they are already using. Those pages pass
   * false and get the plain form column, leaving by the Back button instead.
   */
  showcase?: boolean
  children: ReactNode
}

export function OnboardingShell({
  title,
  showcase = true,
  children,
}: OnboardingShellProps) {
  const form = (
    <>
      <h1 className="text-2xl font-bold text-ink-900 sm:text-3xl">{title}</h1>

      <div className="card-pad mt-6">{children}</div>
    </>
  )

  if (showcase) {
    return (
      // Nothing opposite the logo: no "Exit onboarding" link, and not the default tagline either.
      // The logo still goes back to the home page.
      <AuthLayout wide headerEnd={<span />}>
        {form}
      </AuthLayout>
    )
  }

  return (
    <div className="min-h-screen bg-sun-hero">
      <div className="mx-auto max-w-xl px-4 py-8 sm:py-10">{form}</div>
    </div>
  )
}
